import cookies from 'js.cookie';
import { SUPPORTED_LANGUAGES } from "../constants/constants";

export const getPathLang = () => {
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split('/');
  if (SUPPORTED_LANGUAGES.includes(pathParts[1])) {
    return pathParts[1];
  }
  return null;
};

export const changePathLang = (lng) => {
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split('/');
  
  // Replace the existing language code with the new one
  if (SUPPORTED_LANGUAGES.includes(pathParts[1])) {
    pathParts[1] = lng;
  } else {
    if (pathParts[0] === "") {
      pathParts.shift(); // remove empty string at the beginning
    }
    pathParts.unshift(lng);
  }

  const newPath = pathParts.join('/');
  return newPath;
};

export const getCookieLang = () => {
  return cookies.get("i18next");
};
